module.exports = __webpack_public_path__ + "static/media/Project1_Demo11.7299c087.png";